import { Controller } from "@hotwired/stimulus"

// Handles the insert-point "+" dropdown between blocks.
// Posts to add_block with a specific at_index.
export default class extends Controller {
  static targets = ["dropdown", "trigger"]
  static values = { baseUrl: String, atIndex: Number }

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    const dropdown = this.dropdownTarget
    const isOpen = !dropdown.classList.contains("hidden")

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.dropdownTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.boundClickOutside)
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.boundClickOutside)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  async addBlock(event) {
    event.stopPropagation()
    const blockType = event.currentTarget.dataset.blockType
    if (!blockType) return

    this.close()

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const url = `${this.baseUrlValue}/add_block`

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html, text/html"
        },
        body: JSON.stringify({ block_type: blockType, at_index: this.atIndexValue })
      })

      if (response.ok) {
        window.location.href = `${this.baseUrlValue}?block_index=${this.atIndexValue}`
      }
    } catch (error) {
      console.error("Insert block failed:", error)
    }
  }
}
